import { render, staticRenderFns } from "./NotificationVerify.vue?vue&type=template&id=5de8a24a&"
import script from "./NotificationVerify.vue?vue&type=script&lang=js&"
export * from "./NotificationVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports